<section class="icon-grid">
    <figure *ngFor="let icon of allIcons | keyvalue" class="icon-grid__icon">
        <svg-icon [key]="icon.key" fontSize="2em"></svg-icon>
        <figcaption class="icon-grid__label"><pre>{{ icon.key }}</pre></figcaption>
    </figure>
</section>
